<template>
    <OnboardingLayout v-bind="appSharedData.getOnboardingLayoutProps()">
        <template #content>
            <OnboardingStepContainer
                :showStepsIndicator="true"
                :stepNumber="5"
            >
                <template #title>Connect your calendar</template>
                <template #subtitle>
                    Avoid double bookings and add meeting links automatically.
                    You can skip this for now and connect later.
                </template>
                <template #content>
                    <div class="block w-full max-w-2xl mx-auto">
                        <div class="max-w-2xl mx-auto w-full">
                            <div class="space-y-2">
                                <div
                                    v-for="provider in providers"
                                    :key="provider.key"
                                >
                                    <OnboardingIntegrationCard
                                        :providerKey="provider.key"
                                        :providers="providers"
                                        :isConnected="
                                            isProviderConnected(provider.key)
                                        "
                                        :isHighligthed="
                                            IntegrationProviderEnumData[
                                                provider.key
                                            ].isHighlightedDuringOnboarding
                                        "
                                        :redirectUrl="
                                            getProviderRedirectUrl(provider.key)
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template #action></template>
            </OnboardingStepContainer>
        </template>

        <template #footerRight>
            <ApiForm
                method="POST"
                :url="RoutePathAppEnum.Onboarding_Step5_Integrations"
                ref="apiFormRef"
            >
                <Button
                    @click="apiFormRef?.submit()"
                    iconName="arrow-right"
                    color="primary"
                    :iconRight="true"
                    :loading="apiFormRef?.loading.valueOf()"
                >
                    Continue
                </Button>
            </ApiForm>
        </template>
    </OnboardingLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import OnboardingLayout from '@/Shared/Layout/Onboarding/OnboardingLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import OnboardingStepContainer from '@/App/Company/Component/OnboardingStepContainer.vue'
    import {
        IntegrationProviderEnum,
        IntegrationProviderEnumData,
        type IntegrationProviderDataType,
    } from '@/Shared/AutoGenerated/Main'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import OnboardingIntegrationCard from '@/App/Company/Component/OnboardingIntegrationCard.vue'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'

    interface ShowOnboardingStepIntegrationProps {
        appSharedDataData: any
        providers: IntegrationProviderDataType[]
        connectedProviders: ProviderConnectionStatus[]
    }

    interface ProviderConnectionStatus {
        providerKey: IntegrationProviderEnum
        isConnected: boolean
    }

    const props = defineProps<ShowOnboardingStepIntegrationProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const apiFormRef = ref<ApiFormRefType>(null)

    // TODO: Reuse this duplicated bit of code, its all over the place
    const getProviderRedirectUrl = (providerKey: string | undefined) => {
        return props.providers.find((provider) => provider.key === providerKey)
            ?.redirectUrl
    }

    // TODO: Reuse this duplicated bit of code, its all over the place
    const isProviderConnected = (providerKey: string): boolean => {
        const providerData = props.connectedProviders.find(
            (providerConnectionStatus: ProviderConnectionStatus) => {
                return providerConnectionStatus.providerKey === providerKey
            },
        )

        if (!providerData) {
            throw new Error('Provider should not be null', {
                cause: [providerKey, props.connectedProviders, props.providers],
            })
        }

        return providerData.isConnected
    }
</script>
